/**
 * The kind of surface a saved dynamic filter is scoped to.
 */ export var DynamicFilterScopeType = /*#__PURE__*/ function(DynamicFilterScopeType) {
    /** Visible across the app, independent of the current plan or view (`id` is the constant {@link GlobalDynamicFilterScopeId}). */ DynamicFilterScopeType["Global"] = "global";
    /** Scoped to a single plan (`id` is the plan id) */ DynamicFilterScopeType["Plan"] = "plan";
    /** Scoped to the My Tasks view (`id` identifies the My Tasks surface) */ DynamicFilterScopeType["MyTasks"] = "myTasks";
    return DynamicFilterScopeType;
}({});
export const GlobalDynamicFilterScopeId = "global";
/** Ready-made scope for the app-wide global surface. */ export const GlobalDynamicFilterScope = {
    type: "global",
    id: GlobalDynamicFilterScopeId
};
